// https://github.com/jfkhoury/elementsFromPoint/blob/master/lib/elementsFromPoint.js

if (typeof document.elementsFromPoint !== 'function') {
  document.elementsFromPoint = function (x, y) {
    var elements = [],
      previousPointerEvents = [],
      current,
      i,
      d;

    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {
      elements.push(current);
      previousPointerEvents.push({
        value: current.style.getPropertyValue('pointer-events'),
        priority: current.style.getPropertyPriority('pointer-events'),
      });
      current.style.setProperty('pointer-events', 'none', 'important');
    }
    for (i = previousPointerEvents.length; (d = previousPointerEvents[--i]); ) {
      elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    }

    return elements;
  };
}
